import axios from "axios";
import algoliasearch from "algoliasearch/lite";
import { insightsClient } from "@algolia/client-insights";
import recommend from "@algolia/recommend";

export interface AlgoliaApiConfig {
  application_id: string;
  search_api_key: string;
  index_name: string;
}

export const getAlgoliaClient = async (
  language: string,
  market: string,
  algoliaServiceUrl: string,
) => {
  let algoliaApiConfig: AlgoliaApiConfig;
  try {
    algoliaApiConfig = (
      await axios.request({
        baseURL: algoliaServiceUrl,
        url: `/algolia/v2/context/products?market=${market}&language=${language}`,
        method: "GET",
      })
    ).data;
  } catch (error) {
    console.error(
      `Error when getting api config data from algolia service, can't initialize algolia client with given data. language: ${language}.`,
    );
    return undefined;
  }

  if (!algoliaApiConfig) {
    return undefined;
  }

  return {
    searchClient: algoliasearch(
      algoliaApiConfig.application_id,
      algoliaApiConfig.search_api_key,
    ),
    insightsClient: insightsClient(
      algoliaApiConfig.application_id,
      algoliaApiConfig.search_api_key,
    ),
    recommendClient: recommend(
      algoliaApiConfig.application_id,
      algoliaApiConfig.search_api_key,
    ),
    indexName: algoliaApiConfig.index_name,
  };
};
